module.exports = __webpack_public_path__ + "img/opening.4003d824.png";